import {
    IVanillaReaderOptionsStoreData, IVanillaReaderStoreTtsOptions,
    IVanillaReaderStoreUiActionKeyCommand, IVanillaReaderStoreUiColorPalette,
    IVanillaReaderStoreUiOptionsData,
    IVanillaReaderStoreUiReadingRulerOptions,
    StoreCssMixBlendModeValues,
    VanillaReaderStoreRendererNames,
    VanillaReaderStoreUiActionNames
} from "./VanillaReaderStoreModel";
import {
    IVanillaReaderOptionsData,
    IVanillaReaderTtsOptions, IVanillaReaderUiColorTheme,
    VanillaReaderRendererNames
} from "../VanillaReader/VanillaReaderModel";
import {
    CssMixBlendModeValues,
    IVanillaReaderUiActionKeyCommand,
    IVanillaReaderUiOptionsData,
    IVanillaReaderUiReadingRulerOptions,
    VanillaReaderUiActionNames
} from "../VanillaReaderUI/VanillaReaderUiModel";
import {
    VanillaReaderPublicationIndexedDbDataStoreConversions
} from "./VanillaReaderPublicationIndexedDbDataStoreConversions";

export class VanillaReaderOptionsIndexedDbDataStoreConversions {
    private static toApplicationData(state: IVanillaReaderOptionsStoreData): IVanillaReaderOptionsData {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            viewOptions: state.viewOptions,
            syncMediaOptions: state.syncMediaOptions
        }
    }

    static maybeToApplicationData(state: IVanillaReaderOptionsStoreData | undefined): IVanillaReaderOptionsData | undefined {
        return state ? VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationData(state) : undefined;
    }

    static toStoreData(state: IVanillaReaderOptionsData): IVanillaReaderOptionsStoreData {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            viewOptions: state.viewOptions,
            syncMediaOptions: state.syncMediaOptions
        }
    }

    static maybeToUiApplicationData(state: IVanillaReaderStoreUiOptionsData | undefined): IVanillaReaderUiOptionsData | undefined {
        return state ? VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationUiOptionsData(state) : undefined;
    }

    private static toApplicationUiReadingRulerOptions(options: IVanillaReaderStoreUiReadingRulerOptions | undefined): IVanillaReaderUiReadingRulerOptions | undefined {
        if (options){
            return {
                overlayIsVisible: options.overlayIsVisible,
                overlayBackgroundColor: options.overlayBackgroundColor,
                overlayOpacity: options.overlayOpacity,
                overlayMixBlendMode: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationCssMixBlendModeValues(options.overlayMixBlendMode),
                rulerBackgroundColor: options.rulerBackgroundColor,
                rulerOpacity: options.rulerOpacity,
                rulerMixBlendMode: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationCssMixBlendModeValues(options.rulerMixBlendMode),
                rulerMinHeight: options.rulerMinHeight,
                rulerDragThreshold: options.rulerDragThreshold,
                rulerBorderTopWidth: options.rulerBorderTopWidth,
                rulerBorderBottomWidth: options.rulerBorderBottomWidth,
                rulerBorderLeftWidth: options.rulerBorderLeftWidth,
                rulerBorderRightWidth: options.rulerBorderRightWidth,
                rulerBorderTopColor: options.rulerBorderTopColor,
                rulerBorderBottomColor: options.rulerBorderBottomColor,
                rulerBorderLeftColor: options.rulerBorderLeftColor,
                rulerBorderRightColor: options.rulerBorderRightColor,
                lineBoxBackgroundColor: options.lineBoxBackgroundColor,
                lineBoxOpacity: options.lineBoxOpacity,
                lineBoxMixBlendMode: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationCssMixBlendModeValues(options.lineBoxMixBlendMode),
                lineBoxLineVerticalSpacing: options.lineBoxLineVerticalSpacing,
                lineBoxBorderTopWidth: options.lineBoxBorderTopWidth,
                lineBoxBorderBottomWidth: options.lineBoxBorderBottomWidth,
                lineBoxBorderLeftWidth: options.lineBoxBorderLeftWidth,
                lineBoxBorderRightWidth: options.lineBoxBorderRightWidth,
                lineBoxBorderTopColor: options.lineBoxBorderTopColor,
                lineBoxBorderBottomColor: options.lineBoxBorderBottomColor,
                lineBoxBorderLeftColor: options.lineBoxBorderLeftColor,
                lineBoxBorderRightColor: options.lineBoxBorderRightColor,
                lineBoxMinHeight: options.lineBoxMinHeight,
                lineBoxMaxHeight: options.lineBoxMaxHeight,
                lineBoxLineSpan: options.lineBoxLineSpan,
                snapToLineBoxes: options.snapToLineBoxes,
            }
        } else {
            return;
        }
    }

    private static toStoreUiReadingRulerOptions(options: IVanillaReaderUiReadingRulerOptions | undefined): IVanillaReaderStoreUiReadingRulerOptions | undefined {
        if (options){
            return {
                overlayIsVisible: options.overlayIsVisible,
                overlayBackgroundColor: options.overlayBackgroundColor,
                overlayOpacity: options.overlayOpacity,
                overlayMixBlendMode: VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreCssMixBlendModeValues(options.overlayMixBlendMode),
                rulerBackgroundColor: options.rulerBackgroundColor,
                rulerOpacity: options.rulerOpacity,
                rulerMixBlendMode: VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreCssMixBlendModeValues(options.rulerMixBlendMode),
                rulerMinHeight: options.rulerMinHeight,
                rulerDragThreshold: options.rulerDragThreshold,
                rulerBorderTopWidth: options.rulerBorderTopWidth,
                rulerBorderBottomWidth: options.rulerBorderBottomWidth,
                rulerBorderLeftWidth: options.rulerBorderLeftWidth,
                rulerBorderRightWidth: options.rulerBorderRightWidth,
                rulerBorderTopColor: options.rulerBorderTopColor,
                rulerBorderBottomColor: options.rulerBorderBottomColor,
                rulerBorderLeftColor: options.rulerBorderLeftColor,
                rulerBorderRightColor: options.rulerBorderRightColor,
                lineBoxBackgroundColor: options.lineBoxBackgroundColor,
                lineBoxOpacity: options.lineBoxOpacity,
                lineBoxMixBlendMode: VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreCssMixBlendModeValues(options.lineBoxMixBlendMode),
                lineBoxLineVerticalSpacing: options.lineBoxLineVerticalSpacing,
                lineBoxBorderTopWidth: options.lineBoxBorderTopWidth,
                lineBoxBorderBottomWidth: options.lineBoxBorderBottomWidth,
                lineBoxBorderLeftWidth: options.lineBoxBorderLeftWidth,
                lineBoxBorderRightWidth: options.lineBoxBorderRightWidth,
                lineBoxBorderTopColor: options.lineBoxBorderTopColor,
                lineBoxBorderBottomColor: options.lineBoxBorderBottomColor,
                lineBoxBorderLeftColor: options.lineBoxBorderLeftColor,
                lineBoxBorderRightColor: options.lineBoxBorderRightColor,
                lineBoxMinHeight: options.lineBoxMinHeight,
                lineBoxMaxHeight: options.lineBoxMaxHeight,
                lineBoxLineSpan: options.lineBoxLineSpan,
                snapToLineBoxes: options.snapToLineBoxes,
            }
        } else {
            return;
        }
    }

    private static toApplicationUiOptionsData(state: IVanillaReaderStoreUiOptionsData): IVanillaReaderUiOptionsData {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            showNarrationControls: state.showNarrationControls,
            ignoreAspectRatio: state.ignoreAspectRatio,
            useReducedMotion: state.useReducedMotion,
            useDarkMode: state.useDarkMode,
            activeRendererTypeName: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationRendererTypeName(state.activeRendererTypeName),
            activeUiPaletteName: state.activeUiPaletteName,
            activePublicationPaletteName: state.activePublicationPaletteName,
            activePublicationFontSetName: state.activePublicationFontSetName,
            publicationStyleOptions: state.publicationStyleOptions ? VanillaReaderPublicationIndexedDbDataStoreConversions.toApplicationPublicationStyleOptions(state.publicationStyleOptions) : undefined,
            mediaPlayerPlaybackRate: state.mediaPlayerPlaybackRate,
            ttsOptions: VanillaReaderOptionsIndexedDbDataStoreConversions.maybeToApplicationTtsOptions(state.ttsOptions),
            useAccessibilityMode: state.useAccessibilityMode,
            uIActionKeyCommands: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationUiActionKeyCommands(state.uIActionKeyCommands),
            showReadingRuler: state.showReadingRuler,
            readingRulerOptions: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationUiReadingRulerOptions(state.readingRulerOptions),
            showPageNumbers: state.showPageNumbers,
            scrollOverflowingTables: state.scrollOverflowingTables
        }
    }

    static toStoreUiOptionsData(state: IVanillaReaderUiOptionsData): IVanillaReaderStoreUiOptionsData {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            showNarrationControls: state.showNarrationControls,
            ignoreAspectRatio: state.ignoreAspectRatio,
            useReducedMotion: state.useReducedMotion,
            useDarkMode: state.useDarkMode,
            activeRendererTypeName: VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreRendererTypeName(state.activeRendererTypeName),
            activeUiPaletteName: state.activeUiPaletteName,
            activePublicationPaletteName: state.activePublicationPaletteName,
            activePublicationFontSetName: state.activePublicationFontSetName,
            publicationStyleOptions: state.publicationStyleOptions ?
                VanillaReaderPublicationIndexedDbDataStoreConversions.toStorePublicationStyleOptions(state.publicationStyleOptions):
                undefined,
            mediaPlayerPlaybackRate: state.mediaPlayerPlaybackRate,
            ttsOptions: VanillaReaderOptionsIndexedDbDataStoreConversions.maybeToStoreTtsOptions(state.ttsOptions),
            useAccessibilityMode: state.useAccessibilityMode,
            uIActionKeyCommands: VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreUiActionKeyCommands(state.uIActionKeyCommands),
            fontSets: undefined,
            palettes: undefined,
            showReadingRuler: state.showReadingRuler,
            readingRulerOptions: VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreUiReadingRulerOptions(state.readingRulerOptions),
            showPageNumbers: state.showPageNumbers,
            scrollOverflowingTables: state.scrollOverflowingTables
        }
    }

    private static toApplicationCssMixBlendModeValues(value: StoreCssMixBlendModeValues | undefined): CssMixBlendModeValues | undefined {
        if (value){
            switch (value) {
                case StoreCssMixBlendModeValues.INHERIT: return CssMixBlendModeValues.INHERIT
                case StoreCssMixBlendModeValues.INITIAL: return CssMixBlendModeValues.INITIAL
                case StoreCssMixBlendModeValues.REVERT: return CssMixBlendModeValues.REVERT
                case StoreCssMixBlendModeValues.REVERT_LAYER: return CssMixBlendModeValues.REVERT_LAYER
                case StoreCssMixBlendModeValues.UNSET: return CssMixBlendModeValues.UNSET
                case StoreCssMixBlendModeValues.NORMAL: return CssMixBlendModeValues.NORMAL
                case StoreCssMixBlendModeValues.MULTIPLY: return CssMixBlendModeValues.MULTIPLY
                case StoreCssMixBlendModeValues.SCREEN: return CssMixBlendModeValues.SCREEN
                case StoreCssMixBlendModeValues.OVERLAY: return CssMixBlendModeValues.OVERLAY
                case StoreCssMixBlendModeValues.DARKEN: return CssMixBlendModeValues.DARKEN
                case StoreCssMixBlendModeValues.LIGHTEN: return CssMixBlendModeValues.LIGHTEN
                case StoreCssMixBlendModeValues.COLOR_DODGE: return CssMixBlendModeValues.COLOR_DODGE
                case StoreCssMixBlendModeValues.COLOR_BURN: return CssMixBlendModeValues.COLOR_BURN
                case StoreCssMixBlendModeValues.HARD_LIGHT: return CssMixBlendModeValues.HARD_LIGHT
                case StoreCssMixBlendModeValues.SOFT_LIGHT: return CssMixBlendModeValues.SOFT_LIGHT
                case StoreCssMixBlendModeValues.DIFFERENCE: return CssMixBlendModeValues.DIFFERENCE
                case StoreCssMixBlendModeValues.EXCLUSION: return CssMixBlendModeValues.EXCLUSION
                case StoreCssMixBlendModeValues.HUE: return CssMixBlendModeValues.HUE
                case StoreCssMixBlendModeValues.SATURATION: return CssMixBlendModeValues.SATURATION
                case StoreCssMixBlendModeValues.COLOR: return CssMixBlendModeValues.COLOR
                case StoreCssMixBlendModeValues.LUMINOSITY: return CssMixBlendModeValues.LUMINOSITY

            }
        } else {
            return;
        }
    }

    private static toStoreCssMixBlendModeValues(value: CssMixBlendModeValues | undefined): StoreCssMixBlendModeValues | undefined {
        if (value){
            switch (value) {
                case CssMixBlendModeValues.INHERIT: return StoreCssMixBlendModeValues.INHERIT
                case CssMixBlendModeValues.INITIAL: return StoreCssMixBlendModeValues.INITIAL
                case CssMixBlendModeValues.REVERT: return StoreCssMixBlendModeValues.REVERT
                case CssMixBlendModeValues.REVERT_LAYER: return StoreCssMixBlendModeValues.REVERT_LAYER
                case CssMixBlendModeValues.UNSET: return StoreCssMixBlendModeValues.UNSET
                case CssMixBlendModeValues.NORMAL: return StoreCssMixBlendModeValues.NORMAL
                case CssMixBlendModeValues.MULTIPLY: return StoreCssMixBlendModeValues.MULTIPLY
                case CssMixBlendModeValues.SCREEN: return StoreCssMixBlendModeValues.SCREEN
                case CssMixBlendModeValues.OVERLAY: return StoreCssMixBlendModeValues.OVERLAY
                case CssMixBlendModeValues.DARKEN: return StoreCssMixBlendModeValues.DARKEN
                case CssMixBlendModeValues.LIGHTEN: return StoreCssMixBlendModeValues.LIGHTEN
                case CssMixBlendModeValues.COLOR_DODGE: return StoreCssMixBlendModeValues.COLOR_DODGE
                case CssMixBlendModeValues.COLOR_BURN: return StoreCssMixBlendModeValues.COLOR_BURN
                case CssMixBlendModeValues.HARD_LIGHT: return StoreCssMixBlendModeValues.HARD_LIGHT
                case CssMixBlendModeValues.SOFT_LIGHT: return StoreCssMixBlendModeValues.SOFT_LIGHT
                case CssMixBlendModeValues.DIFFERENCE: return StoreCssMixBlendModeValues.DIFFERENCE
                case CssMixBlendModeValues.EXCLUSION: return StoreCssMixBlendModeValues.EXCLUSION
                case CssMixBlendModeValues.HUE: return StoreCssMixBlendModeValues.HUE
                case CssMixBlendModeValues.SATURATION: return StoreCssMixBlendModeValues.SATURATION
                case CssMixBlendModeValues.COLOR: return StoreCssMixBlendModeValues.COLOR
                case CssMixBlendModeValues.LUMINOSITY: return StoreCssMixBlendModeValues.LUMINOSITY

            }
        } else {
            return;
        }
    }

    private static toApplicationUiActionKeyCommands(commands: IVanillaReaderStoreUiActionKeyCommand[] | undefined): IVanillaReaderUiActionKeyCommand[] | undefined {
        if (commands){
            return commands.map(command => {
                return {
                    actionName: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationUiActionName(command?.actionName),
                    key: command.key,
                    modifiers: command?.modifiers
                }
            });
        } else {
            return;
        }
    }

    private static toStoreUiActionKeyCommands(commands: IVanillaReaderUiActionKeyCommand[] | undefined): IVanillaReaderStoreUiActionKeyCommand[] | undefined {
        if (commands){
            return commands.map(command => {
                return {
                    actionName: VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreUiActionName(command?.actionName),
                    key: command.key,
                    modifiers: command?.modifiers
                }
            });
        } else {
            return;
        }
    }

    private static toApplicationUiActionName(name: VanillaReaderStoreUiActionNames): VanillaReaderUiActionNames {
        switch (name) {
            case VanillaReaderStoreUiActionNames.ACTIONS_MENU_OPEN: return VanillaReaderUiActionNames.ACTIONS_MENU_OPEN
            case VanillaReaderStoreUiActionNames.MAIN_MENU_OPEN: return VanillaReaderUiActionNames.MAIN_MENU_OPEN
            case VanillaReaderStoreUiActionNames.WHERE_AM_I: return VanillaReaderUiActionNames.WHERE_AM_I
            case VanillaReaderStoreUiActionNames.TOC_OPEN_DIALOG: return VanillaReaderUiActionNames.TOC_OPEN_DIALOG
            case VanillaReaderStoreUiActionNames.NAVIGATE_NEXT: return VanillaReaderUiActionNames.NAVIGATE_NEXT
            case VanillaReaderStoreUiActionNames.NAVIGATE_PREVIOUS: return VanillaReaderUiActionNames.NAVIGATE_PREVIOUS
            case VanillaReaderStoreUiActionNames.NAVIGATE_NEXT_HEADING: return VanillaReaderUiActionNames.NAVIGATE_NEXT_HEADING
            case VanillaReaderStoreUiActionNames.NAVIGATE_PREVIOUS_HEADING: return VanillaReaderUiActionNames.NAVIGATE_PREVIOUS_HEADING
            case VanillaReaderStoreUiActionNames.HIGHLIGHT_OPEN_DIALOG_ALL: return VanillaReaderUiActionNames.HIGHLIGHT_OPEN_DIALOG_ALL
            case VanillaReaderStoreUiActionNames.HIGHLIGHT_OPEN_DIALOG_ACTIVE: return VanillaReaderUiActionNames.HIGHLIGHT_OPEN_DIALOG_ACTIVE
            case VanillaReaderStoreUiActionNames.HIGHLIGHT_SELECTION: return VanillaReaderUiActionNames.HIGHLIGHT_SELECTION
            case VanillaReaderStoreUiActionNames.HIGHLIGHT_CLIPBOARD: return VanillaReaderUiActionNames.HIGHLIGHT_CLIPBOARD
            case VanillaReaderStoreUiActionNames.HIGHLIGHT_READING_POSITION: return VanillaReaderUiActionNames.HIGHLIGHT_READING_POSITION
            case VanillaReaderStoreUiActionNames.HIGHLIGHT_ACTIVE_CONTENT: return VanillaReaderUiActionNames.HIGHLIGHT_ACTIVE_CONTENT
            case VanillaReaderStoreUiActionNames.BOOKMARK_SELECTION: return VanillaReaderUiActionNames.BOOKMARK_SELECTION
            case VanillaReaderStoreUiActionNames.BOOKMARK_CLIPBOARD: return VanillaReaderUiActionNames.BOOKMARK_CLIPBOARD
            case VanillaReaderStoreUiActionNames.BOOKMARK_READING_POSITION: return VanillaReaderUiActionNames.BOOKMARK_READING_POSITION
            case VanillaReaderStoreUiActionNames.BOOKMARK_OPEN_DIALOG_ALL: return VanillaReaderUiActionNames.BOOKMARK_OPEN_DIALOG_ALL
            case VanillaReaderStoreUiActionNames.BOOKMARK_OPEN_DIALOG_ACTIVE: return VanillaReaderUiActionNames.BOOKMARK_OPEN_DIALOG_ACTIVE
            case VanillaReaderStoreUiActionNames.SEARCH_DIALOG_OPEN: return VanillaReaderUiActionNames.SEARCH_DIALOG_OPEN
            case VanillaReaderStoreUiActionNames.SEARCH_CLEAR: return VanillaReaderUiActionNames.SEARCH_CLEAR
            case VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_START: return VanillaReaderUiActionNames.MEDIA_PLAYBACK_START
            case VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_STOP: return VanillaReaderUiActionNames.MEDIA_PLAYBACK_STOP
            case VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_SKIP_FORWARD: return VanillaReaderUiActionNames.MEDIA_PLAYBACK_SKIP_FORWARD
            case VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_SKIP_BACKWARD: return VanillaReaderUiActionNames.MEDIA_PLAYBACK_SKIP_BACKWARD
            case VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_ESCAPE_SEGMENT: return VanillaReaderUiActionNames.MEDIA_PLAYBACK_ESCAPE_ACTIVE_SEGMENT
            case VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_ESCAPE_ALL: return VanillaReaderUiActionNames.MEDIA_PLAYBACK_ESCAPE_ALL
            case VanillaReaderStoreUiActionNames.HELP_DIALOG_OPEN: return VanillaReaderUiActionNames.HELP_DIALOG_OPEN
            case VanillaReaderStoreUiActionNames.ACCESSIBILITY_MODE_ENTER: return VanillaReaderUiActionNames.ACCESSIBILITY_MODE_ENTER
            case VanillaReaderStoreUiActionNames.ACCESSIBILITY_MODE_EXIT: return VanillaReaderUiActionNames.ACCESSIBILITY_MODE_EXIT
            case VanillaReaderStoreUiActionNames.SETTINGS_DIALOG_OPEN: return VanillaReaderUiActionNames.SETTINGS_DIALOG_OPEN
            case VanillaReaderStoreUiActionNames.SETTINGS_RESET: return VanillaReaderUiActionNames.SETTINGS_RESET
            case VanillaReaderStoreUiActionNames.BOOKSHELF_DIALOG_OPEN: return VanillaReaderUiActionNames.BOOKSHELF_DIALOG_OPEN
            case VanillaReaderStoreUiActionNames.CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION: return VanillaReaderUiActionNames.CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION
            case VanillaReaderStoreUiActionNames.GOTO_PAGE_DIALOG_OPEN: return VanillaReaderUiActionNames.GOTO_PAGE_DIALOG_OPEN
            case VanillaReaderStoreUiActionNames.ZOOM_TOOL_ACTIVATE: return VanillaReaderUiActionNames.ZOOM_TOOL_ACTIVATE
            case VanillaReaderStoreUiActionNames.ZOOM_TOOL_DEACTIVATE: return VanillaReaderUiActionNames.ZOOM_TOOL_DEACTIVATE
            case VanillaReaderStoreUiActionNames.ZOOM_OUT: return VanillaReaderUiActionNames.ZOOM_OUT
            case VanillaReaderStoreUiActionNames.ZOOM_IN: return VanillaReaderUiActionNames.ZOOM_IN
            case VanillaReaderStoreUiActionNames.ZOOM_RESET: return VanillaReaderUiActionNames.ZOOM_RESET
            case VanillaReaderStoreUiActionNames.READING_RULER_ACTIVATE: return VanillaReaderUiActionNames.READING_RULER_ACTIVATE
            case VanillaReaderStoreUiActionNames.READING_RULER_DEACTIVATE: return VanillaReaderUiActionNames.READING_RULER_DEACTIVATE
            case VanillaReaderStoreUiActionNames.READING_RULER_MOVE_NEXT: return VanillaReaderUiActionNames.READING_RULER_MOVE_NEXT
            case VanillaReaderStoreUiActionNames.READING_RULER_MOVE_PREVIOUS: return VanillaReaderUiActionNames.READING_RULER_MOVE_PREVIOUS
            case VanillaReaderStoreUiActionNames.LANDMARKS_DIALOG_OPEN: return VanillaReaderUiActionNames.LANDMARKS_DIALOG_OPEN
            case VanillaReaderStoreUiActionNames.NAVIGATION_HISTORY_DIALOG_OPEN: return VanillaReaderUiActionNames.NAVIGATION_HISTORY_DIALOG_OPEN
        }
    }

    private static toStoreUiActionName(name: VanillaReaderUiActionNames): VanillaReaderStoreUiActionNames {
        switch (name) {
            case VanillaReaderUiActionNames.ACTIONS_MENU_OPEN: return VanillaReaderStoreUiActionNames.ACTIONS_MENU_OPEN
            case VanillaReaderUiActionNames.MAIN_MENU_OPEN: return VanillaReaderStoreUiActionNames.MAIN_MENU_OPEN
            case VanillaReaderUiActionNames.WHERE_AM_I: return VanillaReaderStoreUiActionNames.WHERE_AM_I
            case VanillaReaderUiActionNames.TOC_OPEN_DIALOG: return VanillaReaderStoreUiActionNames.TOC_OPEN_DIALOG
            case VanillaReaderUiActionNames.NAVIGATE_NEXT: return VanillaReaderStoreUiActionNames.NAVIGATE_NEXT
            case VanillaReaderUiActionNames.NAVIGATE_PREVIOUS: return VanillaReaderStoreUiActionNames.NAVIGATE_PREVIOUS
            case VanillaReaderUiActionNames.NAVIGATE_NEXT_HEADING: return VanillaReaderStoreUiActionNames.NAVIGATE_NEXT_HEADING
            case VanillaReaderUiActionNames.NAVIGATE_PREVIOUS_HEADING: return VanillaReaderStoreUiActionNames.NAVIGATE_PREVIOUS_HEADING
            case VanillaReaderUiActionNames.HIGHLIGHT_OPEN_DIALOG_ALL: return VanillaReaderStoreUiActionNames.HIGHLIGHT_OPEN_DIALOG_ALL
            case VanillaReaderUiActionNames.HIGHLIGHT_OPEN_DIALOG_ACTIVE: return VanillaReaderStoreUiActionNames.HIGHLIGHT_OPEN_DIALOG_ACTIVE
            case VanillaReaderUiActionNames.HIGHLIGHT_SELECTION: return VanillaReaderStoreUiActionNames.HIGHLIGHT_SELECTION
            case VanillaReaderUiActionNames.HIGHLIGHT_CLIPBOARD: return VanillaReaderStoreUiActionNames.HIGHLIGHT_CLIPBOARD
            case VanillaReaderUiActionNames.HIGHLIGHT_READING_POSITION: return VanillaReaderStoreUiActionNames.HIGHLIGHT_READING_POSITION
            case VanillaReaderUiActionNames.HIGHLIGHT_ACTIVE_CONTENT: return VanillaReaderStoreUiActionNames.HIGHLIGHT_ACTIVE_CONTENT
            case VanillaReaderUiActionNames.BOOKMARK_SELECTION: return VanillaReaderStoreUiActionNames.BOOKMARK_SELECTION
            case VanillaReaderUiActionNames.BOOKMARK_CLIPBOARD: return VanillaReaderStoreUiActionNames.BOOKMARK_CLIPBOARD
            case VanillaReaderUiActionNames.BOOKMARK_READING_POSITION: return VanillaReaderStoreUiActionNames.BOOKMARK_READING_POSITION
            case VanillaReaderUiActionNames.BOOKMARK_OPEN_DIALOG_ALL: return VanillaReaderStoreUiActionNames.BOOKMARK_OPEN_DIALOG_ALL
            case VanillaReaderUiActionNames.BOOKMARK_OPEN_DIALOG_ACTIVE: return VanillaReaderStoreUiActionNames.BOOKMARK_OPEN_DIALOG_ACTIVE
            case VanillaReaderUiActionNames.SEARCH_DIALOG_OPEN: return VanillaReaderStoreUiActionNames.SEARCH_DIALOG_OPEN
            case VanillaReaderUiActionNames.SEARCH_CLEAR: return VanillaReaderStoreUiActionNames.SEARCH_CLEAR
            case VanillaReaderUiActionNames.MEDIA_PLAYBACK_START: return VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_START
            case VanillaReaderUiActionNames.MEDIA_PLAYBACK_STOP: return VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_STOP
            case VanillaReaderUiActionNames.MEDIA_PLAYBACK_SKIP_FORWARD: return VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_SKIP_FORWARD
            case VanillaReaderUiActionNames.MEDIA_PLAYBACK_SKIP_BACKWARD: return VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_SKIP_BACKWARD
            case VanillaReaderUiActionNames.MEDIA_PLAYBACK_ESCAPE_ACTIVE_SEGMENT: return VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_ESCAPE_SEGMENT
            case VanillaReaderUiActionNames.MEDIA_PLAYBACK_ESCAPE_ALL: return VanillaReaderStoreUiActionNames.MEDIA_PLAYBACK_ESCAPE_ALL
            case VanillaReaderUiActionNames.HELP_DIALOG_OPEN: return VanillaReaderStoreUiActionNames.HELP_DIALOG_OPEN
            case VanillaReaderUiActionNames.ACCESSIBILITY_MODE_ENTER: return VanillaReaderStoreUiActionNames.ACCESSIBILITY_MODE_ENTER
            case VanillaReaderUiActionNames.ACCESSIBILITY_MODE_EXIT: return VanillaReaderStoreUiActionNames.ACCESSIBILITY_MODE_EXIT
            case VanillaReaderUiActionNames.SETTINGS_DIALOG_OPEN: return VanillaReaderStoreUiActionNames.SETTINGS_DIALOG_OPEN
            case VanillaReaderUiActionNames.SETTINGS_RESET: return VanillaReaderStoreUiActionNames.SETTINGS_RESET
            case VanillaReaderUiActionNames.BOOKSHELF_DIALOG_OPEN: return VanillaReaderStoreUiActionNames.BOOKSHELF_DIALOG_OPEN
            case VanillaReaderUiActionNames.CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION: return VanillaReaderStoreUiActionNames.CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION
            case VanillaReaderUiActionNames.GOTO_PAGE_DIALOG_OPEN: return VanillaReaderStoreUiActionNames.GOTO_PAGE_DIALOG_OPEN
            case VanillaReaderUiActionNames.ZOOM_TOOL_ACTIVATE: return VanillaReaderStoreUiActionNames.ZOOM_TOOL_ACTIVATE
            case VanillaReaderUiActionNames.ZOOM_TOOL_DEACTIVATE: return VanillaReaderStoreUiActionNames.ZOOM_TOOL_DEACTIVATE
            case VanillaReaderUiActionNames.ZOOM_OUT: return VanillaReaderStoreUiActionNames.ZOOM_OUT
            case VanillaReaderUiActionNames.ZOOM_IN: return VanillaReaderStoreUiActionNames.ZOOM_IN
            case VanillaReaderUiActionNames.ZOOM_RESET: return VanillaReaderStoreUiActionNames.ZOOM_RESET
            case VanillaReaderUiActionNames.READING_RULER_ACTIVATE: return VanillaReaderStoreUiActionNames.READING_RULER_ACTIVATE
            case VanillaReaderUiActionNames.READING_RULER_DEACTIVATE: return VanillaReaderStoreUiActionNames.READING_RULER_DEACTIVATE
            case VanillaReaderUiActionNames.READING_RULER_MOVE_NEXT: return VanillaReaderStoreUiActionNames.READING_RULER_MOVE_NEXT
            case VanillaReaderUiActionNames.READING_RULER_MOVE_PREVIOUS: return VanillaReaderStoreUiActionNames.READING_RULER_MOVE_PREVIOUS
            case VanillaReaderUiActionNames.LANDMARKS_DIALOG_OPEN: return VanillaReaderStoreUiActionNames.LANDMARKS_DIALOG_OPEN
            case VanillaReaderUiActionNames.NAVIGATION_HISTORY_DIALOG_OPEN: return VanillaReaderStoreUiActionNames.NAVIGATION_HISTORY_DIALOG_OPEN
        }
    }

    private static toApplicationRendererTypeName(name: VanillaReaderStoreRendererNames | undefined): VanillaReaderRendererNames | undefined {
        if (name){
            switch (name) {
                case VanillaReaderStoreRendererNames.FLIPBOOK:
                    return VanillaReaderRendererNames.FLIPBOOK
                case VanillaReaderStoreRendererNames.STACK:
                    return VanillaReaderRendererNames.STACK
                case VanillaReaderStoreRendererNames.RESPONSIVE:
                    return VanillaReaderRendererNames.RESPONSIVE
                case VanillaReaderStoreRendererNames.SCROLL:
                    return VanillaReaderRendererNames.SCROLL
                case VanillaReaderStoreRendererNames.SWIPE_SINGLE:
                    return VanillaReaderRendererNames.SWIPE_SINGLE
                case VanillaReaderStoreRendererNames.SWIPE_SPREAD:
                    return VanillaReaderRendererNames.SWIPE_SPREAD;
            }
        } else {
            return;
        }
    }

    private static toStoreRendererTypeName(name: VanillaReaderRendererNames | undefined): VanillaReaderStoreRendererNames | undefined {
        if (name){
            switch (name) {
                case VanillaReaderRendererNames.FLIPBOOK:
                    return VanillaReaderStoreRendererNames.FLIPBOOK
                case VanillaReaderRendererNames.STACK:
                    return VanillaReaderStoreRendererNames.STACK
                case VanillaReaderRendererNames.RESPONSIVE:
                    return VanillaReaderStoreRendererNames.RESPONSIVE
                case VanillaReaderRendererNames.SCROLL:
                    return VanillaReaderStoreRendererNames.SCROLL
                case VanillaReaderRendererNames.SWIPE_SINGLE:
                    return VanillaReaderStoreRendererNames.SWIPE_SINGLE
                case VanillaReaderRendererNames.SWIPE_SPREAD:
                    return VanillaReaderStoreRendererNames.SWIPE_SPREAD;
            }
        } else {
            return;
        }
    }

    static toApplicationTtsOptions(storeData: IVanillaReaderStoreTtsOptions): IVanillaReaderTtsOptions {
        return {
            voiceName: storeData.voiceName,
            highlightColor: storeData.highlightColor,
            volume: storeData.volume,
            rate: storeData.rate
        }
    }

    static maybeToApplicationTtsOptions(storeData: IVanillaReaderStoreTtsOptions | undefined): IVanillaReaderTtsOptions | undefined {
        return storeData ? VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationTtsOptions(storeData) : undefined;
    }

    static maybeToStoreTtsOptions(storeData: IVanillaReaderTtsOptions | undefined): IVanillaReaderStoreTtsOptions | undefined {
        return storeData ? VanillaReaderOptionsIndexedDbDataStoreConversions.toStoreTtsOptions(storeData) : undefined;
    }


    static toStoreTtsOptions(appData: IVanillaReaderTtsOptions): IVanillaReaderStoreTtsOptions {
        return {
            voiceName: appData.voiceName,
            highlightColor: appData.highlightColor,
            volume: appData.volume,
            rate: appData.rate
        }
    }

    static maybeToApplicationPalette(palettes?: {
        Default: IVanillaReaderStoreUiColorPalette;
        Dark: IVanillaReaderStoreUiColorPalette;
        ContrastDark: IVanillaReaderStoreUiColorPalette;
        Paperlike: IVanillaReaderStoreUiColorPalette;
    }): ({
        Default: IVanillaReaderUiColorTheme;
        Dark: IVanillaReaderUiColorTheme;
        ContrastDark: IVanillaReaderUiColorTheme;
        Paperlike: IVanillaReaderUiColorTheme;
    }| undefined) {
        if (palettes){
            return ({
                Default: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.Default),
                Dark: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.Dark),
                ContrastDark: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.ContrastDark),
                Paperlike: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.Paperlike),
            })
        } else {
            return;
        }
    }

    static maybeToStorePalette(palettes?: {
        Default: IVanillaReaderUiColorTheme;
        Dark: IVanillaReaderUiColorTheme;
        ContrastDark: IVanillaReaderUiColorTheme;
        Paperlike: IVanillaReaderUiColorTheme;
    }): ({
        Default: IVanillaReaderStoreUiColorPalette;
        Dark: IVanillaReaderStoreUiColorPalette;
        ContrastDark: IVanillaReaderStoreUiColorPalette;
        Paperlike: IVanillaReaderStoreUiColorPalette;
    }| undefined) {
        if (palettes){
            return ({
                Default: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.Default),
                Dark: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.Dark),
                ContrastDark: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.ContrastDark),
                Paperlike: VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(palettes.Paperlike),
            })
        } else {
            return;
        }
    }

    static toApplicationStoreUiColorPalette(storeData: IVanillaReaderStoreUiColorPalette): IVanillaReaderUiColorTheme {
        return {
            foregroundDark: storeData.foregroundDark,
            foregroundLight: storeData.foregroundLight,
            backgroundDark: storeData.backgroundDark,
            backgroundLight: storeData.backgroundLight,
            accent: storeData.accent,
            name: storeData.name,
            uiIsDark: storeData.uiIsDark,
            uiOutlineDark: storeData.uiOutlineDark,
            uiOutlineLight: storeData.uiOutlineLight,
            uiBackgroundDark: storeData.uiBackgroundDark,
            uiBackgroundLight: storeData.uiBackgroundLight,
            uiForegroundDark: storeData.uiForegroundDark,
            uiForegroundLight: storeData.uiForegroundLight
        }
    }

    static maybeToApplicationStoreUiColorPalette(storeData: IVanillaReaderStoreUiColorPalette | undefined): IVanillaReaderStoreUiColorPalette | undefined {
        return storeData ? VanillaReaderOptionsIndexedDbDataStoreConversions.toApplicationStoreUiColorPalette(storeData) : undefined;
    }

    static toStoreStoreUiColorPalette(appData: IVanillaReaderUiColorTheme): IVanillaReaderStoreUiColorPalette {
        return {
            foregroundDark: appData.foregroundDark,
            foregroundLight: appData.foregroundLight,
            backgroundDark: appData.backgroundDark,
            backgroundLight: appData.backgroundLight,
            accent: appData.accent,
            name: appData.name,
            uiIsDark: appData.uiIsDark,
            uiOutlineDark: appData.uiOutlineDark,
            uiOutlineLight: appData.uiOutlineLight,
            uiBackgroundDark: appData.uiBackgroundDark,
            uiBackgroundLight: appData.uiBackgroundLight,
            uiForegroundDark: appData.uiForegroundDark,
            uiForegroundLight: appData.uiForegroundLight
        }
    }

}
